import enCommon from './resources/en_US/common.json';
import enAuth from './resources/en_US/auth.json';
import enValidation from './resources/en_US/validation.json';
import enErrors from './resources/en_US/errors.json';
import enWorkflow from './resources/en_US/workflow.json';
import enNavigation from './resources/en_US/navigation.json';
import enHr from './resources/en_US/hr.json';
import enNotifications from './resources/en_US/notifications.json';
import enToast from './resources/en_US/toast.json';
import enPos from './resources/en_US/pos.json';
import enWork from './resources/en_US/work.json';
import enOrg from './resources/en_US/org.json';
import enFinance from './resources/en_US/finance.json';
import enCrm from './resources/en_US/crm.json';
import enDesk from './resources/en_US/desk.json';
import enProcurement from './resources/en_US/procurement.json';
import enIdentity from './resources/en_US/identity.json';
import enLeadgen from './resources/en_US/leadgen.json';
import enMarketing from './resources/en_US/marketing.json';
import enOnboarding from './resources/en_US/onboarding.json';
import enProjects from './resources/en_US/projects.json';
import enSocial from './resources/en_US/social.json';
import enWarehouse from './resources/en_US/warehouse.json';
import enMaster from './resources/en_US/master.json';
import enInventory from './resources/en_US/inventory.json';

import frCommon from './resources/fr_FR/common.json';
import frAuth from './resources/fr_FR/auth.json';
import frValidation from './resources/fr_FR/validation.json';
import frErrors from './resources/fr_FR/errors.json';
import frWorkflow from './resources/fr_FR/workflow.json';
import frNavigation from './resources/fr_FR/navigation.json';
import frHr from './resources/fr_FR/hr.json';
import frNotifications from './resources/fr_FR/notifications.json';
import frToast from './resources/fr_FR/toast.json';
import frPos from './resources/fr_FR/pos.json';
import frWork from './resources/fr_FR/work.json';
import frOrg from './resources/fr_FR/org.json';
import frFinance from './resources/fr_FR/finance.json';
import frCrm from './resources/fr_FR/crm.json';
import frDesk from './resources/fr_FR/desk.json';
import frProcurement from './resources/fr_FR/procurement.json';
import frIdentity from './resources/fr_FR/identity.json';
import frLeadgen from './resources/fr_FR/leadgen.json';
import frMarketing from './resources/fr_FR/marketing.json';
import frOnboarding from './resources/fr_FR/onboarding.json';
import frProjects from './resources/fr_FR/projects.json';
import frSocial from './resources/fr_FR/social.json';
import frWarehouse from './resources/fr_FR/warehouse.json';
import frMaster from './resources/fr_FR/master.json';
import frInventory from './resources/fr_FR/inventory.json';

export const DEFAULT_LANGUAGE_CODE = 'en_US';

export const SUPPORTED_LANGUAGE_CODES = ['en_US', 'fr_FR'] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGE_CODES)[number];

export function normalizeLanguageCode(code?: string | null): LanguageCode {
  const trimmed = code?.trim();
  if (trimmed === 'fr_FR' || trimmed === 'fr-FR' || trimmed === 'fr') {
    return 'fr_FR';
  }
  return 'en_US';
}

export function languageCodeToDir(code: string): 'ltr' | 'rtl' {
  return code.startsWith('ar_') ? 'rtl' : 'ltr';
}

export function buildI18nResources() {
  return {
    en_US: {
      common: enCommon,
      auth: enAuth,
      validation: enValidation,
      errors: enErrors,
      workflow: enWorkflow,
      navigation: enNavigation,
      hr: enHr,
      notifications: enNotifications,
      toast: enToast,
      pos: enPos,
      work: enWork,
      org: enOrg,
      finance: enFinance,
      crm: enCrm,
      desk: enDesk,
      procurement: enProcurement,
      identity: enIdentity,
      leadgen: enLeadgen,
      marketing: enMarketing,
      onboarding: enOnboarding,
      projects: enProjects,
      social: enSocial,
      warehouse: enWarehouse,
      master: enMaster,
      inventory: enInventory,
    },
    fr_FR: {
      common: frCommon,
      auth: frAuth,
      validation: frValidation,
      errors: frErrors,
      workflow: frWorkflow,
      navigation: frNavigation,
      hr: frHr,
      notifications: frNotifications,
      toast: frToast,
      pos: frPos,
      work: frWork,
      org: frOrg,
      finance: frFinance,
      crm: frCrm,
      desk: frDesk,
      procurement: frProcurement,
      identity: frIdentity,
      leadgen: frLeadgen,
      marketing: frMarketing,
      onboarding: frOnboarding,
      projects: frProjects,
      social: frSocial,
      warehouse: frWarehouse,
      master: frMaster,
      inventory: frInventory,
    },
  } as const;
}
